export enum PollType {
  SINGLE_SELECT = 'SINGLE_SELECT',

  MULTI_SELECT = 'MULTI_SELECT',
}
